// extracted by mini-css-extract-plugin
export default {"collapsibleBlockLabel":"CollapsibleBlockLabel_collapsibleBlockLabel__haDWn"};